import { useInfiniteQuery } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { StoresContext } from '../../../provider/StoreProvider'

import { getEventList } from '../../../api/event'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { CenterWrap } from '../../../components/common'
import { Header } from '../../../components/header'
import { Spinner } from '../../../components/spinner/Spinner'
import { EmptyPage } from '../../../components/exception/EmptyPage'
import { InfinityScroll } from '../../../components/pagingList/InfinityScroll'

export function EventList() {
  const {
    commonStore: { setShowTab },
  } = useContext(StoresContext)

  const { data, isPending, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [QUERY_KEY.eventList],
    queryFn: async ({ pageParam = 0 }) => await getEventList({ offset: pageParam, size: 50 }),
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.offset + lastPage.size),
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })

  useEffect(() => {
    setShowTab(false)
  }, [])

  if (isPending) {
    return (
      <Wrap>
        <Header type="SUB" title="이벤트" />
        <CenterWrap>
          <Spinner />
        </CenterWrap>
      </Wrap>
    )
  }

  if (isError || !data.pages.length) {
    return (
      <Wrap>
        <Header type="SUB" title="이벤트" />
        <EmptyPage content="조회 가능한 이벤트가 없습니다." />
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Header type="SUB" title="이벤트" />
      <StyledContent id="infinity-scroll-target">
        <InfinityScroll length={data.pages.length} isLast={!hasNextPage} next={fetchNextPage}>
          {data.pages.map(({ id, imageUri, title }) => (
            <Link key={id} to={`/event/${id}`}>
              <ImageThumbnail>
                <img
                  src={imageUri}
                  alt={title}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null
                    currentTarget.src = '/img/thumbnail.svg'
                  }}
                />
              </ImageThumbnail>
            </Link>
          ))}
        </InfinityScroll>
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)`
  div.infinite-scroll-component {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px;
  }
`

const ImageThumbnail = styled.div`
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 0.22;
  border-radius: 8px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
